import React from 'react';
import {
  LinkPreview as ReactLinkPreview,
  LinkPreviewProps as ReactLinkPreviewProps,
} from './LinkPreviewCard';
import { useColorModeValue } from '@cardboard-ui/react';

export const LinkPreview: React.FC<ReactLinkPreviewProps> = (props) => {
  const backgroundColor = useColorModeValue('white', '#4A5568');
  const primaryTextColor = useColorModeValue('black', 'white');
  const secondaryTextColor = useColorModeValue('gray', 'lightgray');
  return (
    <ReactLinkPreview
      className="editorLinkCard"
      backgroundColor={backgroundColor}
      borderColor="lightgray"
      primaryTextColor={primaryTextColor}
      secondaryTextColor={secondaryTextColor}
      {...props}
    />
  );
};
